import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './fonts.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import ReferalApp from './referral/ReferralApp';
import { setTrackingUserId } from './helpers/tracker';
import Cookies from 'js-cookie';

ReactDOM.render(
    <React.StrictMode>
        <AppContent />
    </React.StrictMode>,
    document.getElementById('root')
);

function AppContent() {
    useEffect(() => {
        let userId = Cookies.get('yandexuid');
        setTrackingUserId(userId);
    }, [])
    
    return <Router>
        <Switch>
            <Route path="**/referral">
                <ReferalApp />
            </Route>
            <Route>
                <App />
            </Route>
        </Switch>
    </Router>
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
